import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ReplaceVideoPointsService from '../../Services/Mutations/ReplaceContentPoints'
import ModifyContentPoints from '../../Services/Mutations/ModifyContentPoints'
import DeleteContentInSingleLanguage from '../../Services/Mutations/DeleteContentInSingleLanguage'
import DeleteContent from '../../Services/Mutations/DeleteContent'
import AddContentToBoxOffice from '../../Services/Mutations/AddContentToBoxOffice'
class AddContentToBoxOfficeAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contentSelectedLang: null,
      addToBoxOfficeModalVisible: false,
      selectedContentId: '',
      selectedContentLanguages: [],
      capturePostModal: false,
      selectedItem: null,
    }
  }
  handleAddToBoxOffice = async () => {
    const item = this.state.selectedContentId
    this.setState({ addToBoxOfficeModalVisible: false })
    let loggedInUserHandle = ''
    const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
    if (loggedInUserEmail) {
      const emailParams = loggedInUserEmail.split('@')
      loggedInUserHandle = '@' + emailParams[0]
    }
    const input = {
      contentID: item.PK,
      ModeratorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
      appInfoFrontEnd: {
        UUID: Auth.user.username,
        appVersionNumber: 62,
      },
    }
    console.log(input, 'inputtttt')
    const data = await AddContentToBoxOffice(input)
    console.log(data, 'dataaaaa')
    if (data.statusCode == 'A295') {
      this.props.displayToast('success', 'Content Added To Box office Successfully')
      this.props.updateArchivedList(item.PK, false)
    } else {
      this.props.displayToast('success', 'Failed to add content to box office')
    }
  }

  openAddToBoxOfficeModal = (item) => {
    this.setState({ selectedContentId: item, addToBoxOfficeModalVisible: true })
  }
  closeAddToBoxOfficeModal = (item) => {
    this.setState({ selectedContentId: '', addToBoxOfficeModalVisible: false })
  }
  renderAddToBoxOfficeConfirmationModal = () => {
    const { addToBoxOfficeModalVisible } = this.state
    return (
      <Modal show={addToBoxOfficeModalVisible} onHide={() => this.closeAddToBoxOfficeModal()}>
        <Modal.Body>
          <div className='row'>
            <text>Are you sure you want to add this content to boxoffice?</text>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeAddToBoxOfficeModal()}>Cancel</Button>
          <Button onClick={() => this.handleAddToBoxOffice()}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }
  render() {
    const {
      pointsModalVisible,
      modifyType,
      otherPoints,
      modifyPoints,
      mask,
      replacePoints,
    } = this.state
    return (
      <div>
        {this.props.rank ? (
          <div
            onClick={() => {
              this.openAddToBoxOfficeModal(this.props.item)
            }}
          >
            <label>Add Content To Box Office</label>
          </div>
        ) : (
          <div
            class='col-md-2'
            onClick={() => {
              this.openAddToBoxOfficeModal(this.props.item)
            }}
          >
            <i class='fas fa-star' />
          </div>
        )}

        {this.renderAddToBoxOfficeConfirmationModal()}
      </div>
    )
  }
}

export default AddContentToBoxOfficeAction
